// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const c2gApi = createApi({
    reducerPath: 'c2gApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://c2g-api-funcs-dev.azurewebsites.net/api/',
        mode: 'cors',
        prepareHeaders: (headers) => {
            // headers.set("x-functions-key", apiKey)
            return headers
        }
    }),
    endpoints: (builder) => ({
        postHello: builder.query({
            query: (sendWhat) => ({
                url: 'message',
                method: 'POST',
                body: sendWhat
            }),
        }),
        sayHello: builder.query({
            query: () => ({
                url: 'message',
                method: 'GET'
            }),
        }),
        getRate: builder.query({
            query: (sendWhat) => ({
                url: 'xRate',
                method: 'POST',
                body: sendWhat
            }),
        }),
        getOffer: builder.query({
            query: (sendWhat) => ({
                url: 'offer',
                method: 'POST',
                body: {
                    ...sendWhat,
                    browserTime: (Date.now() / 1000).toString()
                }
            }),
            transformResponse: (response, meta, arg) => response.result,
            transformErrorResponse: (response, meta, arg) => response.error
        }),
        getOrderStatus: builder.query({
            query: (sendWhat) => ({
                url: 'orderStatus',
                method: 'POST',
                body: sendWhat
            }),
        }),
        getOrderHistory: builder.query({
            query: (sendWhat) => ({
                url: 'orderHistory',
                method: 'POST',
                body: sendWhat
            }),
        }),
    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { 
    usePostHelloQuery,
    useSayHelloQuery,
    useGetRateQuery,
    useGetOfferQuery,
    useGetOrderStatusQuery,
    useGetOrderHistoryQuery,
} = c2gApi

